import React, { useEffect } from 'react';
import { Route, Routes } from "react-router-dom";
import { useAuth } from "./hooks/useAuth";

// Admin Wrapper (header, left nav, etc)
import Admin from './Admin';

// Components 
import AnhiProgramTable from './components/anhi-program-table'

import NeurelisResources from './components/neurelis-resources'
import NeurelisPodcasts from './components/neurelis-podcasts'
import NeurelisMSL from './components/neurelis-msl'
import NeurelisEvents from './components/neurelis-events'
import NeurelisSearch from './components/neurelis-search'
import NeurelisHomepage from './components/neurelis-homepage'

import NeurelisMicroHomepage from './components/neurelisMicro-homepage'
import NeurelisMicroEvents from './components/neurelisMicro-events'
import NeurelisMicroResources from './components/neurelisMicro-resources'

import TestOne from './components/test-test-1'
import TestTwo from './components/test-test-2'
import Users from './components/users'
import Audit from './components/audit'

import { ProtectedRoute } from "./components/ProtectedRoute";

// Pages
import { Error} from './pages/Error';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard'



const AppWrapper =  () => {
	const { user } = useAuth();
	const menu = []
	const routes = []
	
	
	if (user && user.sections) {
		
		let objDefaultRoute = null
		if (user.sections.addesso) {
			menu.push({
				
				items: [
					{ label: "Home", icon: "fas fa-home", to: "/dashboard" }
				]
	
			})
		}
		
		
		// ANHI Items
		if (user.sections.addesso || user.sections.anhi) {
			menu.push(
				{ separator: true },
				{
					label: "ANHI",
					items: [
						{ label: "Programs", icon: "fas fa-calendar", to: "/anhi-programs" }
					]
				}
			)
			routes.push(
				<Route path="/anhi-programs" element={<AnhiProgramTable /> } key="anhiPrograms" />
			)

			objDefaultRoute = <Route path="/" element={<AnhiProgramTable /> } key="anhiProgramsDefault" />
		} 

		// NEURELIS Items
		if (user.sections.addesso || user.sections.neurelis) {
			menu.push(
				{ separator: true },
				{
					label: "Neurelis",
					items: [
						{ label: "Home Page", icon: "fas fa-image", to: "/neurelis-homepage" },
						{ label: "Resources", icon: "fas fa-bolt", to: "/neurelis-resources" },
						{ label: "Podcasts", icon: "fas fa-music", to: "/neurelis-podcasts" },
						{ label: "MSL", icon: "fas fa-map", to: "/neurelis-msl" },
						{ label: "Events", icon: "fas fa-calendar", to: "/neurelis-events" },
						{ label: "Search", icon: "fas fa-search", to: "/neurelis-search" }
					]
				},
			)

			routes.push(
				<Route path="/neurelis-homepage" element={<NeurelisHomepage />} key="neurelisHomepage" />,
				<Route path="/neurelis-resources" element={<NeurelisResources />} key="neurelisResources" />,
				<Route path="/neurelis-msl" element={<NeurelisMSL />} key="neurelisMSL" />,
				<Route path="/neurelis-podcasts" element={<NeurelisPodcasts />} key="neurelisPodcasts" />,
				<Route path="/neurelis-events" element={<NeurelisEvents />} key="neurelisEvents" />,
				<Route path="/neurelis-search" element={<NeurelisSearch />} key="neurelisSearch" />
			)

			if (!objDefaultRoute) objDefaultRoute = <Route path="/" element={<NeurelisResources /> } key="neurelisResourcesDefault" />
		} 

		// NEURELIS Microsite Items
		if (user.sections.addesso || user.sections.neurelismicro) {
			menu.push(
				{ separator: true },
				{
					label: "Neurelis Patient MS",
					items: [
						{ label: "Home Page", icon: "fas fa-image", to: "/neurelismicro-homepage" },
						{ label: "Resources", icon: "fas fa-bolt", to: "/neurelismicro-resources" },
						{ label: "Events", icon: "fas fa-calendar", to: "/neurelismicro-events" },
						
					]
				},
			)

			routes.push(
				<Route path="/neurelismicro-homepage" element={<NeurelisMicroHomepage />} key="neurelisMicroHomepage" />,
				<Route path="/neurelismicro-resources" element={<NeurelisMicroResources />} key="neurelisMicroResources" />,
				<Route path="/neurelismicro-events" element={<NeurelisMicroEvents />} key="neurelisMicroEvents" />,
			)

			if (!objDefaultRoute) objDefaultRoute = <Route path="/" element={<NeurelisMicroResources /> } key="neurelisResourcesDefault" />
		} 

		

		if (user.sections.addesso) {
			menu.push(
				{ separator: true },
				{
					label: "Addesso Admin",
					items: [
						{ label: "Users", icon: "fas fa-users", to: "/users" },
						{ label: "Audit", icon: "fas fa-boxes", to: "/audit" }
					]
				}
			)

			routes.push(
				<Route path="/dashboard" element={<Dashboard />} key="Dashboard" />,
				<Route path="/users" element={<Users />} key="users" />,
				<Route path="/audit" element={<Audit />} key="audit" />,
			)
			objDefaultRoute = <Route path="/" element={<Dashboard /> } key="DashboardDefault" />
		}

		routes.push(objDefaultRoute)
	}
	
	return (
		<Routes>
        	<Route path="login" element={<Login />} />
			<Route element={<ProtectedRoute />}>
				<Route path="/" element={<Admin menu={menu} />}>
					{routes}
				</Route>
				<Route path="*" element={<Error />} />
			</Route>
      </Routes>
	)
}

export default AppWrapper;
